import { pushToGTM, sendCorporateMixpanelPageEvent, sendCorporateMixpanelTrackEvent } from "@lib/gtmUtility"
import { GA_EVENT_COMMON } from "@constants"

const eventObjBase = {
    category: "",
    action: "",
    label: "",
    eventName: "newGAEvent",
}

const addEvent = ({ label, action, eventName, category }, eventData = {}) => {
    const eventObj = Object.assign({}, eventObjBase)
    if (!category) {
        eventObj.category = "Home"
    }
    eventObj.action = action
    eventObj.label = label
    if (category) eventObj.category = category
    if (eventName) eventObj.eventName = eventName
    else eventObj.eventName = "newGAEvent"
    pushToGTM(eventObj, eventData)
}

export default {
    onPageViewEvent: (label, category) => {
        addEvent({
            label,
            action: "Page View Action",
            eventName: GA_EVENT_COMMON.pageViewEventName,
            category,
        })
    },
    onSolutionsClick: (category, label) => {
        addEvent({
            category,
            label,
            action: "cta_click_our_solutions",
        })
    },
    onOnemgLogoClick: (category, label) => {
        addEvent({
            category,
            label,
            action: "cta_click_tata_1mg",
        })
    },
    onHomeClick: (category, label) => {
        addEvent({
            category,
            label,
            action: "cta_click_home",
        })
    },
    onAboutUsClick: (category) => {
        addEvent({
            category,
            action: "cta_click_about_us",
        })
    },
    onContactUsClick: (category) => {
        addEvent({
            category,
            action: "cta_click_contact_us",
        })
    },
    onGetIntouchClick: (category, label) => {
        addEvent({
            category,
            label,
            action: "cta_get_in_touch",
        })
    },
}

export const MixpanelEvents = {
    onPageViewEvent: (props = {}) => {
        sendCorporateMixpanelPageEvent("corporate_partnership_page_viewed", props)
    },
    onOurSolutionsClick: (props = {}) => {
        sendCorporateMixpanelTrackEvent("cta_click_our_solutions", props)
    },
    onOneMgLogoClick: (props = {}) => {
        sendCorporateMixpanelTrackEvent("cta_click_tata_1mg", props)
    },
    onHomeCtaClick: (props = {}) => {
        sendCorporateMixpanelTrackEvent("cta_click_home", props)
    },
    onAboutUsCtaClick: (props = {}) => {
        sendCorporateMixpanelTrackEvent("cta_click_about_us", props)
    },
    onContactUsCtaClick: (props = {}) => {
        sendCorporateMixpanelTrackEvent("cta_click_contact_us", props)
    },
    onGetInTouchCtaClick: (props = {}) => {
        sendCorporateMixpanelTrackEvent("cta_get_in_touch", props)
    },
}
